// extracted by mini-css-extract-plugin
export default {"wrapper":"HeroSection_wrapper__S07r-","hero":"HeroSection_hero__4eoqT","backdrop":"HeroSection_backdrop__xfj00","backdropOne":"HeroSection_backdropOne__OMMC+"};